import { ActionNode } from '../Action/TypedNode'
import { VariableModel } from '../Variable/ViewModel'
import { ActionCallVariableDefinition } from './TypedDefinition'

import type { ActionSpecific } from '../Action/TypedNode'
import type { AnyExpressionSpecific } from '../Mustache'
import type { ViewScope } from '@rehaje/core'

export interface ActionCallVariableSpecific extends ActionSpecific {
  props: {
    value?: any
    variableId?: AnyExpressionSpecific | string
  }
  type: `Action.CallVariable`
}

export interface CallVariableProps {
  value?: any
  variableId?: string
}

export class ActionCallVariableNode extends ActionNode {
  static definition = ActionCallVariableDefinition

  override async handler(props: CallVariableProps, scope: ViewScope) {
    if (props.variableId) {
      const model = scope.variables[props.variableId]
      const value = props.value
      if (model instanceof VariableModel) {
        model.setValue(value)
      }
    }
  }
}

declare global {
  export interface RehajeSpecifics {
    'Action.CallVariable': ActionCallVariableSpecific
  }
  export interface RehajeTypedNodes {
    'Action.CallVariable': ActionCallVariableNode
  }
}
